import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "AddWriteUpView" }

import { onMounted, ref } from "vue";
import MdEditor from "@/components/MdEditor.vue";
import message from "@arco-design/web-vue/es/message";
import {
  QuestionControllerService,
  WriteUpAddRequest,
  WriteUpControllerService,
} from "../../generated";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddWriteUpView',
  setup(__props) {

const writeup = ref({
  questionId: 0,
  content: "# 题解描述\n",
  tag: ["简单"],
  title: "A + B",
} as WriteUpAddRequest);

const question = ref({
  questionId: 0,
  title: "A + B",
} as any);

const route = useRoute();

const loadData = async () => {
  const id = route.params.id;
  if (!id) {
    return;
  }
  const res: any = await QuestionControllerService.getQuestionVoByIdUsingGet(
    id as any
  );
  if (res.code === 0) {
    question.value = res.data;
    writeup.value.questionId = res.data.questionId;
  } else {
    message.error("加载失败！ " + res.message);
  }
};
onMounted(() => {
  loadData();
});

const onContentChange = (v: string) => {
  writeup.value.content = v;
};

const handleSubmit = async () => {
  const res = await WriteUpControllerService.addWriteUpUsingPost(writeup.value);
  if (res.code === 0) {
    message.success("创建题解成功！");
  } else {
    message.error("创建题解失败 " + res.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h1", null, "编写题解", -1)),
    _createVNode(_component_a_descriptions, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions_item, { label: "题目ID" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(question.value.questionId), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "题目名称" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(question.value.title), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_form, {
      model: writeup.value,
      "label-align": "left",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "标题"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: writeup.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((writeup.value.title) = $event)),
              class: "formItem",
              placeholder: "请输入标题"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "content",
          label: "题解正文"
        }, {
          default: _withCtx(() => [
            _createVNode(MdEditor, {
              "handle-change": onContentChange,
              value: writeup.value.content,
              class: "formItem"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "tag",
          label: "标签"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: writeup.value.tag,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((writeup.value.tag) = $event)),
              "allow-clear": "",
              class: "formItem",
              placeholder: "请输入标签"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          "html-type": "submit",
          style: {"width":"20%"},
          type: "primary"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("提交 ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})